import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    box-shadow: 0px -3px 6px #00000014;
    position: absolute;
    right: 0;
    bottom: 0;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    padding: ${(props) =>
        props.padding ? props.padding : '11px 25px 11px 0px'};

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'center'};
        padding-right: 0px;
    }
    ${media.smalDevice`
    position: absolute;
    right: 0px;
    bottom: 71px;
    `}
    ${media.mobileDevice`
        justify-content: space-evenly;
        padding-right: 10px; 
        padding-top:15px;   `}
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 0px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    ${media.mediumDevice`
        overflow-y: unset;
        padding-right: 0px;
    `}
    ${media.smalDevice`
        overflow-y: unset;
        padding-right: 0px;
    `}
    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 175px;
        padding-right: 0;
    `}
    textarea {
        width: calc(100% - 10px) !important;
        padding: 15px !important;
        font-family: 'AvenirNextWorld Regular';
        border-radius: 6px;
        border: none;
        margin: 0px 0 0 5px;
        box-shadow: 0px 0px 6px #00000029 !important;
        ${media.mediumDevice`
            margin : auto;
            width: calc(100% - 4px) !important
        `}
        ${media.smalDevice`
            margin : auto;
            width: calc(100% - 4px) !important
        `}
        ${media.mobileDevice`
            margin : auto;
            width: calc(100% - 3px) !important;
        `}
        ::placeholder {
            font-family: 'AvenirNextWorld Regular';
            width: 100%;
            font-size: 15px;
            color: #20212480;
        }
    }
`;

export const Footer = styled.div`
    width: 100%;
`;
